export default [
  {
    path: '/member/memberList',
    name: 'memberList',
    meta: {
      keepAlive: true,
      title: '会员列表'
    },
    component: () =>
        import(/* webpackChunkName: "member" */ '@/views/member/memberList.vue')
  },
  {
    path: '/member/memberList/memberDetails',
    name: 'memberDetails',
    meta: {
      title: '会员详情'
    },
    component: () =>
        import(/* webpackChunkName: "member" */ '@/views/member/memberDetails.vue')
  },
  {
    path: '/member/cardRecord',
    name: 'cardRecord',
    meta: {
      title: '线下开卡'
    },
    component: () =>
        import(/* webpackChunkName: "member" */ '@/views/member/cardRecord.vue')
  },
  {
    path: '/member/memberImport/detail',
    name: 'detail',
    meta: {
      title: '已导入用户详情'
    },
    component: () =>
        import(/* webpackChunkName: "member" */ '@/views/member/importDetails.vue')
  },
  {
    path: '/member/memberImport',
    name: 'memberImport',
    meta: {
      keepAlive: true,
      title: '会员导入'
    },
    component: () =>
        import(/* webpackChunkName: "member" */ '@/views/member/memberImport.vue')
  },
  {
    path: '/member/familyList',
    name: 'familyList',
    meta: {
      title: '家庭列表'
    },
    component: () =>
        import(/* webpackChunkName: "member" */ '@/views/member/familyList.vue')
  },
  {
    path: '/member/memberList/diffDispose',
    name: 'diffDispose',
    meta: {
      title: '资金处置'
    },
    component: () =>
        import(/* webpackChunkName: "member" */ '@/views/member/diffDispose.vue')
  },

  // 工作人员管理
  {
    path: '/member/administrator/afterSale',
    name: 'afterSale',
    meta: {
      title: '售后人员刷卡信息'
    },
    component: () =>
        import(/* webpackChunkName: "member" */ '@/views/member/administrator/afterSale.vue')
  },
  {
    path: '/member/administrator/clearCard',
    name: 'clearCard',
    meta: {
      title: '清运人员刷卡信息'
    },
    component: () =>
        import(/* webpackChunkName: "member" */ '@/views/member/administrator/clearCard.vue')
  },
  {
    path: '/member/administrator/checkingIn',
    name: 'checkingIn',
    meta: {
      title: '运营人员考勤信息'
    },
    component: () =>
        import(/* webpackChunkName: "member" */ '@/views/member/administrator/checkingIn.vue')
  },

  {
    path: '/member/administrator/gridding',
    name: 'gridding',
    meta: {
      title: '网格员人员考勤信息'
    },
    component: () =>
        import(/* webpackChunkName: "member" */ '@/views/member/administrator/gridding.vue')
  },
  {
    path: '/member/administrator/swipingCard',
    name: 'swipingCard',
    meta: {
      title: '运营人员刷卡信息'
    },
    component: () =>
        import(/* webpackChunkName: "member" */ '@/views/member/administrator/swipingCard.vue')
  },
  // 工作人员信息录入
  {
    path: '/member/informationEntry/runMessage',
    name: 'runMessage',
    meta: {
      title: '运营人员基本信息'
    },
    component: () =>
        import(/* webpackChunkName: "member" */ '@/views/member/informationEntry/runMessage.vue')
  },
  {
    path: '/member/informationEntry/clearMessage',
    name: 'clearMessage',
    meta: {
      title: '清运人员基本信息'
    },
    component: () =>
        import(/* webpackChunkName: "member" */ '@/views/member/informationEntry/clearMessage.vue')
  },
  {
    path: '/member/informationEntry/afterMessage',
    name: 'afterMessage',
    meta: {
      title: '售后人员基本信息'
    },
    component: () =>
        import(/* webpackChunkName: "member" */ '@/views/member/informationEntry/afterMessage.vue')
  },
  {
    path: '/member/informationEntry/reseauMessage',
    name: 'reseauMessage',
    meta: {
      title: '网格员人员基本信息'
    },
    component: () =>
        import(/* webpackChunkName: "member" */ '@/views/member/informationEntry/reseauMessage.vue')
  },
  {
    path: '/member/informationEntry/informationEntrys',
    name: 'reseauMessage',
    meta: {
      title: '信息录入详情'
    },
    component: () =>
        import(/* webpackChunkName: "member" */ '@/views/member/informationEntry/informationEntrys.vue')
  },
  {
    path: '/administrator/administrators',
    name: 'administrators',
    meta: {
      title: '刷卡信息详情'
    },
    component: () =>
        import(/* webpackChunkName: "member" */ '@/views/member/administrator/administrators.vue')
  }
]

